import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 20 10" {...props}>
      <path d="M4.48297 9.86431C4.78398 9.876 5.0638 9.70358 5.18727 9.42814C5.3122 9.15271 5.25813 8.83051 5.04918 8.60987L2.76899 6.14557L17.1216 6.14557C17.3897 6.14995 17.6381 6.00968 17.7725 5.77735C17.9092 5.54721 17.9092 5.26009 17.7725 5.02995C17.6381 4.79762 17.3897 4.65734 17.1216 4.66173L2.76899 4.66173L5.04918 2.19742C5.23476 2.00308 5.30051 1.72473 5.2216 1.46829C5.14343 1.21112 4.93375 1.01751 4.67293 0.959061C4.40991 0.901343 4.1374 0.989745 3.95913 1.18847L0.0613976 5.40401L3.95913 9.61883C4.09283 9.76714 4.28279 9.857 4.48297 9.86431Z" />
    </Svg>
  );
};

export default Icon;
